import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchBar from '../components/SearchBar';
import CategoryButtons from '../components/CategoryButtons';
import Features from '../components/Features';

const Home = () => {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="py-8 md:py-12">
                    <SearchBar />
                </div>
                <div className="mt-4 md:mt-12">
                    <CategoryButtons />
                </div>
                <div className="mt-12 md:mt-16">
                    <Features />
                </div>
            </div>
        </div>
    );
};

export default Home; 